module.exports = __webpack_public_path__ + "static/img/kefu2.4549f5a2.png";